import axios from "axios";
import { _throw } from "../utils/error-service";
import { API } from '../constants/system';

const auth = (token) => ({ headers: { 'Authorization': token, 'Content-Type': 'application/json' } });

/** Inbox grouped by customer (unread totals, last message). */
export const api_get_support_conversations = async (token, params = {}) => {
  try {
    return await axios.get(`${API}/cms/support-conversations`, { ...auth(token), params });
  } catch (err) {
    console.error('Error fetching support conversations:', err);
    return _throw(err);
  }
};

/** One full thread; the API marks customer messages read. */
export const api_get_support_conversation = async (conversationId, token) => {
  try {
    return await axios.get(`${API}/cms/support-conversations/${conversationId}`, auth(token));
  } catch (err) {
    console.error(`Error fetching conversation ${conversationId}:`, err);
    return _throw(err);
  }
};

export const api_reply_support_conversation = async (conversationId, message, token) => {
  try {
    return await axios.post(`${API}/cms/support-conversations/${conversationId}/messages`, { message }, auth(token));
  } catch (err) {
    console.error(`Error replying to conversation ${conversationId}:`, err);
    return _throw(err);
  }
};

/** Support starts an outbound conversation with a customer. */
export const api_start_support_conversation = async (userId, message, source, token) => {
  try {
    return await axios.post(`${API}/cms/support-conversations`, { userId, message, source }, auth(token));
  } catch (err) {
    console.error('Error starting conversation:', err);
    return _throw(err);
  }
};

export const api_update_support_conversation = async (conversationId, status, token) => {
  try {
    return await axios.put(`${API}/cms/support-conversations/${conversationId}`, { status }, auth(token));
  } catch (err) {
    console.error(`Error updating conversation ${conversationId}:`, err);
    return _throw(err);
  }
};
